import { BreadcrumbItem, Col, Row } from "reactstrap"

import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import useFeatureFlags from "hooks/useFeatureFlags"
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"
import { useDispatch, useSelector } from "react-redux"
import { getCallTranscriptionSettings } from "store/calls/actions"
import { getPrimaryTextClass } from "helpers/sf_utils"

const CallDetailBreadcrumb = props => {

  const { call_transcription_settings, current_account } = useSelector(state => ({
    call_transcription_settings: state.Calls.call_transcription_settings,
    current_account: state.accounts.current_account,
  }));
  const [isFeatureFlagActive] = useFeatureFlags();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCallTranscriptionSettings({ id: current_account.id }));
  }, []);
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <h4 className="text-capitalize text-black mb-0 me-3">
              {props.backOption &&
                <Link to={props.link}>
                  <i className={`bx bx-arrow-back ${getPrimaryTextClass()} font-size-16 me-2 bx-sm`} />
                </Link>
              }
              {props.breadcrumbItem}
            </h4>
            {
              (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CALL_TRANSCRIPTION) && call_transcription_settings?.active) ?
                <div>
                  <button className={`btn me-2 ${props.showSummary || props?.transcription ? 'btn-light' : 'btn-sfblue'}`} onClick={props.handleButtonClickOverview} style={{ width: "fit-content" }} >Overview</button>
                  <button className={`btn ${props.transcription ? 'btn-sfblue' : 'btn-light'} me-2`} onClick={props.handleButtonClickTranscription} style={{ width: "fit-content" }} >Transcription</button>
                  {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSATION_AND_SUMMARY_TAB)
                    && current_account?.call_summary_enabled &&
                    <button className={`btn ${props.showSummary ? 'btn-sfblue' : 'btn-light'} me-2`} style={{ width: "fit-content" }} onClick={props.handleButtonClickSummary}>Summary / Q&A </button>}
                </div>

                : ''
            }
          </div>
          <div className="page-title-right">
            <ol className="breadcrumb m-0 text-black">
              {props.title ?
                <BreadcrumbItem>
                  <Link to="#" className="text-black">{props.title}</Link>
                </BreadcrumbItem> : ''
              }
              <BreadcrumbItem active>
                <Link to="#" className="text-black">
                  {props.transcription ? 'Transcription Detail' : props.showSummary ? 'Summary-Q&A' : 'Call Detail'}
                </Link>
              </BreadcrumbItem>

            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

CallDetailBreadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  backOption: PropTypes.bool,
  link: PropTypes.string,
  handleButtonClickOverview: PropTypes.func,
  handleButtonClickTranscription: PropTypes.func,
  transcription: PropTypes.bool
}

export default CallDetailBreadcrumb
